export default __webpack_public_path__ + "static/media/search-box-icon.a7ca82be.svg";